<!-- Copyright (c) 2022-2024, NVIDIA CORPORATION & AFFILIATES. All rights reserved. -->

<template>
    <div id="header">
        <div class="header-container">
            <img class="header-logo" src="../assets/nvidia_logo.png" alt="NVIDIA logo" />
            <h2 class="header-app-name">NVUE Migration Tool</h2>
        </div>
        <div class="header-right">
            <div class="powered-text">Powered by
                <a href="https://air.nvidia.com" target="_blank">NVIDIA Air</a>
            </div>
            <div class="tooltip">
                <v-popover>
                    <span class="material-icons info-icon cursor-pointer p-10"
                        alt="Help"
                        title="Help"
                    >
                        info
                    </span>
                        <template slot="popover">
                            <span class="tooltiptext">
                                <div class="p-10">
    Need help? Email us at <a href="mailto:air-support@nvidia.com">air-support@nvidia.com</a>.
                                </div>
                            </span>
                        </template>
                </v-popover>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Header',
};
</script>
<style lang="scss" scoped>
@import '~@cumulus/air-ui-kit/variables.scss';

#header {
    height: 48px;
    background-color: #1a1a1a;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;

    .header-container {
        display: flex;
        align-items: center;
        width: fit-content;
    }

    .header-info {
        display: flex;
        align-items: center;
        padding: 0 10px;
    }
}

.header-app-name {
    display: inline-block;
    color: white;
    margin: 0;
}

.header-logo {
    width: 145px;
}

.header-right {
    align-items: center;
    display: flex;
}

.powered-text {
    color: white;
    padding-left: 20px;
}
</style>
